import { AdminFormSection } from '@ui';
import { FacilityLocationDetails } from '@lp/features/admin/forms/components/FacilityLocationDetails';
import { HubBasicDetails } from './HubBasicDetails';
import { HubManagers } from './HubManagers';
import { SuperHubToggle } from './SuperHubToggle';

type NopHubFormType = {
  isReadOnly?: boolean;
};

export const HubForm = ({ isReadOnly = false }: NopHubFormType) => {
  return (
    <AdminFormSection title="NOP Hub Details">
      <HubBasicDetails isReadOnly={isReadOnly} />
      <FacilityLocationDetails isReadOnly={isReadOnly} showRegion />
      <HubManagers isReadOnly={isReadOnly} />
      <SuperHubToggle isReadOnly={isReadOnly} />
    </AdminFormSection>
  );
};
